import { Component, Input, OnInit } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import {
    Validators,
    FormsModule,
    ReactiveFormsModule,
    FormBuilder,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { ItemNumber } from "src/app/core/models/item-number";
import { TypedFormGroup } from "src/app/shared-utils/typed-forms.helper";
import { ItemNumberApiService } from "src/app/core/api/item-number-api.service";

@Component({
    selector: "app-create-item-number-modal",
    standalone: true,
    imports: [
        TranslatePipe,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
    ],
    templateUrl: "./create-item-number-modal.component.html",
    styleUrl: "./create-item-number-modal.component.scss",
})
export class CreateItemNumberModalComponent implements OnInit {
    @Input() public contractDetailsId: number;

    public ItemNumberForm: TypedFormGroup<Partial<ItemNumber>>;

    constructor(
        private formBuilder: FormBuilder,
        private activeModal: NgbActiveModal,
        private itemNumberApiService: ItemNumberApiService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {}

    private buildForm() {
        this.ItemNumberForm = this.formBuilder.group({
            id: [null],
            title: ["", [Validators.required]],
            description: [""],
            hours: [""],
        }) as TypedFormGroup<Partial<ItemNumber>>;
    }

    ngOnInit() {
        this.buildForm();
    }

    onSave() {
        if (this.ItemNumberForm.invalid) {
            this.ItemNumberForm.markAllAsTouched();
            return;
        }
        if (!this.contractDetailsId) {
            return;
        }

        const formValue = this.ItemNumberForm.value;
        const postData: ItemNumber = {
            id: formValue.id ?? 0,
            contractDetailsId: this.contractDetailsId,
            title: formValue.title,
            description: formValue.description,
            hours: formValue.hours,
        };
        this.itemNumberApiService.post(postData).subscribe({
            next: (response) => {
                this.translateService.get('itemNumbers.form.created').subscribe((res: string) => {
                    this.toastrService.success(res);
                });
                this.activeModal.close(response);
            },
            error: () => {
                this.translateService.get('itemNumbers.form.createdError').subscribe((res: string) => {
                    this.toastrService.error(res);
                });
            }
        });
    }

    onClose() {
        this.activeModal.dismiss();
    }
}
